export default {
  label: {
    field: 'Campo',
    groupingBy: 'Agrupar por',
    none: 'Nenhum',
  },
};
